import {addHandler} from './scroll_resize';

// see _constants.scss
export const MAX_MOBILE = 767;
var WIN_WIDTH;

addHandler({
  resize: function (ww) {
    WIN_WIDTH = ww;
  }
});

export function isMobileSite () {
  return WIN_WIDTH <= MAX_MOBILE;
}



// WEBPACK FOOTER //
// ./assets/j/src/constants.js